// Analytics event names
export const AnalyticsEventNames = {
  // Page events
  PAGE_VIEW: 'page_view',
  HOMEPAGE_OPENED: 'homepage_opened',
  
  // Video wizard events
  VIDEO_WIZARD_STEP: 'video_wizard_step',
  VIDEO_WIZARD_CONVERSION: 'video_wizard_conversion',
  VIDEO_CREATED: 'video_created',
  VIDEO_OPENED: 'video_opened',
  VIDEO_DELETED: 'video_deleted',
  VIDEO_UPDATED: 'video_updated',
  
  // Story events
  STORY_CREATED: 'story_created',
  STORY_OPENED: 'story_opened',
  STORY_UPDATED: 'story_updated',
  STORY_DELETED: 'story_deleted',
  
  // Template events
  TEMPLATE_OPENED: 'template_opened',
  TEMPLATE_USED: 'template_used',
  
  // Feature usage
  AI_GENERATION: 'ai_generation',
  EXPRESS_SYNC: 'express_sync',

  //Voiceover related event
  VOICEOVER_CHOSEN: 'voiceover_chosen',
  VOICEOVER_FRAGMENT_REGENERATED: 'voiceover_fragment_regereated',
  ENTIRE_AUDIO_PREVIEWED: 'entire_audio_previewed',
  FRAGMENTED_AUDIO_PREVIEWED: 'fragmented_audio_previewed',
  VOICEOVER_PRONUNCIATION_FIXED: 'voiceover_pronunciation_fixed',
  VOICEOVER_RESET: 'voiceover_reset',
  VOICEOVER_FRAGMENT_EDIT: 'voiceover_fragment_edit',
};

// Analytics variable names
export const AnalyticsVariableNames = {
  USER_EMAIL: 'user_email',
  TIMESTAMP: 'timestamp',
  PAGE_NAME: 'page_name',
  PAGE_URL: 'page_url',
  REFERRER_URL: 'referrer_url',
  VIDEO_ID: 'video_id',
  VIDEO_NAME: 'video_name',
  VIDEO_PATH: 'video_path',
  VIDEO_STEP: 'video_step',
  EXPRESS_ID: 'express_id',
  CUSTOMER_NAME: 'customer_name',
  CUSTOMER_INDUSTRY: 'customer_industry',
  CUSTOMER_DR_NUMBER: 'customer_dr_number',
  ACCOUNT_NAME: 'account_name',
  STORY_ID: 'story_id',
  TEMPLATE_ID: 'template_id',
  VOICEOVER_TEMPLATE: 'voiceover_template',
};

export const eventMap = {
  [AnalyticsEventNames.PAGE_VIEW]: 'event4',
  [AnalyticsEventNames.HOMEPAGE_OPENED]: 'event9',
  [AnalyticsEventNames.VIDEO_WIZARD_STEP]: 'event10',
  [AnalyticsEventNames.VIDEO_WIZARD_CONVERSION]: 'event11',
  [AnalyticsEventNames.VIDEO_CREATED]: 'event12',
  [AnalyticsEventNames.VIDEO_OPENED]: 'event13',
  [AnalyticsEventNames.VIDEO_DELETED]: 'event14',
  [AnalyticsEventNames.VIDEO_UPDATED]: 'event15',
  [AnalyticsEventNames.STORY_CREATED]: 'event16',
  [AnalyticsEventNames.STORY_OPENED]: 'event17',
  [AnalyticsEventNames.STORY_UPDATED]: 'event18',
  [AnalyticsEventNames.STORY_DELETED]: 'event19',
  [AnalyticsEventNames.TEMPLATE_OPENED]: 'event20',
  [AnalyticsEventNames.TEMPLATE_USED]: 'event21',
  [AnalyticsEventNames.AI_GENERATION]: 'event22',
  [AnalyticsEventNames.EXPRESS_SYNC]: 'event23',
  [AnalyticsEventNames.VOICEOVER_CHOSEN]: 'event24',
  [AnalyticsEventNames.VOICEOVER_FRAGMENT_REGENERATED]: 'event25',
  [AnalyticsEventNames.ENTIRE_AUDIO_PREVIEWED]: 'event26',
  [AnalyticsEventNames.FRAGMENTED_AUDIO_PREVIEWED]: 'event27',
  [AnalyticsEventNames.VOICEOVER_PRONUNCIATION_FIXED]: 'event28',
  [AnalyticsEventNames.VOICEOVER_RESET]: 'event29',
  [AnalyticsEventNames.VOICEOVER_FRAGMENT_EDIT]: 'event30',
};

export const variableMap = {
  [AnalyticsVariableNames.USER_EMAIL]: 'prop6',
  [AnalyticsVariableNames.TIMESTAMP]: 'prop7',
  [AnalyticsVariableNames.PAGE_NAME]: 'prop8',
  [AnalyticsVariableNames.PAGE_URL]: 'prop9',
  [AnalyticsVariableNames.REFERRER_URL]: 'prop10',
  [AnalyticsVariableNames.VIDEO_ID]: 'prop11',
  [AnalyticsVariableNames.VIDEO_NAME]: 'prop12',
  [AnalyticsVariableNames.VIDEO_PATH]: 'prop13',
  [AnalyticsVariableNames.VIDEO_STEP]: 'prop14',
  [AnalyticsVariableNames.EXPRESS_ID]: 'prop15',
  [AnalyticsVariableNames.CUSTOMER_NAME]: 'prop16',
  [AnalyticsVariableNames.CUSTOMER_INDUSTRY]: 'prop17',
  [AnalyticsVariableNames.CUSTOMER_DR_NUMBER]: 'prop18',
  [AnalyticsVariableNames.STORY_ID]: 'prop19',
  [AnalyticsVariableNames.TEMPLATE_ID]: 'prop20',
  [AnalyticsVariableNames.ACCOUNT_NAME]: 'prop21',
  [AnalyticsVariableNames.VOICEOVER_TEMPLATE]: 'prop22',
};
